// extracted by mini-css-extract-plugin
export default {"root":"Notice_root__GpWWz","title":"Notice_title__J6klb","footer":"Notice_footer__AygSQ"};